import moment from 'moment';

export const getTimeBeforeDate = (date: Date | string): string => {
    return moment(date).toNow(true);
};
